/*
 *  This file environment.main.ts is part of HROne Inbox. The intelectual property owned by Uneecops Workplace Solution PVT. LTD.
 *  CopyrightYear: 2025
 *  (C) 2015-2025. All Right reserved. Uneecops Workplace Solution PVT. LTD.
 *
 */

export const environment = {
  production: false,
  envName: "production",
  domainCode: "dgn5",
  base_url: "https://test-hrops-api.hrone.work",
  chat_base_url: "https://chat.hrone.cloud",
  stripe_base_url: "https://hronedev-subscription.azurewebsites.net",
  file_size_in_byte: 5000000,
  allow_mixpanel: true,
  mixpanel_token: "61f57e99fa5c3649f47fe8a95b3331b6",
  isDeployOnGT: false,
  redirect_to_hrone_app: "https://test.hrone.work",
  // New Relic Browser Monitoring Configuration
  newRelic: {
    enabled: true, 
    accountID: '1321654',
    trustKey: '1321654',
    agentID: '718418903',
    licenseKey: 'fa0d766433',
    applicationID: '718418903'
  }
};